<template>
    <div @click="goToProject" class="w-full" :class="{'cursor-pointer' : !button}">
        <div class="w-full rounded flex" :class="{'bg-yellow-lighter' : yellow, 'bg-grey-lighter' : !white, 'bg-white' : white}">
            <div class="col-1 flex items-center">
                <span v-if="button && !show" @click="show = !show" class="material-icons text-xl cursor-pointer" name="plus">add</span>
                <span v-if="button && show" @click="show = !show" class="material-icons text-xl cursor-pointer" name="minus">remove</span>
            </div>
            <div class="flex justify-between w-full">
                <div class="col-3">{{ first }}</div>
                <div class="col-2">{{ second }}</div>
                <div class="col-3">{{ third }}</div>
                <div class="col-2"><span v-if="isProjectManagement">Total Contract Amount: </span>{{ fourth }}</div>
                <div class="col-2">{{ five }}</div>
            </div>
        </div>
        <div v-if="show">
            <div class="rounded">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "report-card-row",
        props: {
            button: {required: false, type: Boolean},
            yellow: {required: false, type: Boolean},
            white: {required: false, type: Boolean},
            first: {required: false},
            second: {required: false},
            third: {required: false},
            fourth: {required: false},
            five: {required: false},
            project: {required:false},
            contact: {required:false},
            company: {required:false},
            isProjectManagement: {required:false},
            project_management: {required:false},
            deletedAt: {required:false},
        },
        data() {
            return {
                show: false,
            }
        },
        methods: {
            goToProject() {
                if(this.deletedAt){
                    let message = '';
                    if (this.project || this.project_management){
                        message = 'Your project is deleted';
                    }
                    if (this.contact && this.company){
                        message = 'Your contact is deleted.';
                    }
                    this.getToast().fire({
                        type: 'error',
                        title: message
                    });
                    return;
                }
                if (this.project) {
                    window.location = route('project.edit', {project: this.project, reportCard: true});
                }
                if (this.project_management) {
                    window.location = '/project-management/project/'+this.project_management+'/edit';//route('project-management.project.edit', {project: this.project_management, reportCard: true});
                }
                if (this.contact && this.company) {
                    window.location = 'company/'+this.company+'/contact/'+this.contact+'/edit';
                }
            }
        }
    }
</script>
